import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getDirectDealCurations,
  IGetDirectDealCurationsReturn,
} from '../../../../api/directDealCuration/queries/getDirectDealCurations';

export const useGetDirectDealCurationsQuery = () => {
  return useQuery<IGetDirectDealCurationsReturn, AxiosError>(['direct-deal-curations'], () => getDirectDealCurations());
};
